import React, { useState, useCallback } from 'react';
import {
  Grid,
  Card,
  Typography as MuiTypography,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Switch,
} from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { useStyles } from './styles';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GroupsData, CompanyData, UserData } from 'services/dataService';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { ArrowBackIos, FormatIndentDecreaseSharp } from '@material-ui/icons';
import FileSaver from 'file-saver';

import { exportToCsv, exportToPdf, exportToXlsx } from 'helpers/reportExport';
import { CustomFieldsData } from 'services/dataService';

const exportActionType = {
  csv: (col, responseData, title) => {
    exportToCsv(col, responseData, title);
  },
  pdf: (col, responseData, title) => {
    exportToPdf(col, responseData, title);
  },
  excel: (col, responseData, title) => {
    exportToXlsx(col, responseData, title);
  },
};

export default () => {
  const classes = useStyles();
  const { t } = useTranslation(['label', 'button', 'form', 'files']);
  const [file, setFile] = useState();
  const [group, setGroup] = useState('');
  const [checkEmail, setCheckEmail] = useState(false);
  const [listGroup, setListGroup] = useState([]);
  const [myCompany, setMyCompany] = useState('');
  const [isImporting, setIsImporting] = useState(false);

  const history = useHistory();

  async function getExportFields() {
    try {
      const response = await await CustomFieldsData.getExportFields();
      return response;
    } catch (e) {
      toast.error(t('toastify:commons.toast_error_api'));
    }
  }

  const customExport = useCallback(async (type) => {
    try {
      if (type === 'excel') {
        const { data } = await UserData.getMassiveUserTemplate();
        FileSaver.saveAs(data, 'modelo_importacao_usuarios.xlsx');
        return;
      }

      const columns = await getExportFields();
      let responseData = [];
      let responseDataObj = {};
      for (let i in columns.data) {
        responseDataObj[columns.data[i].title] = columns.data[i].example;
      }
      responseData.push(responseDataObj);
      exportActionType[type](columns.data, responseData, 'csvExample.ac858279');
    } catch (err) {
      toast.error(`No momento não foi possível baixar o arquivo ${type}`);
    }
  }, []);

  async function getPlataform() {
    try {
      const responseCompany = await CompanyData.getCompanyByHostname();
      setMyCompany(responseCompany.data.company);
    } catch (e) {
      toast.error(t('toastify:commons.toast_error_api'));
    }
  }

  async function getGroup() {
    try {
      const responseGroup = await GroupsData.getGroups();
      setListGroup(responseGroup.data.groups.filter((a) => a?.type !== 3));
    } catch (e) {
      toast.error(t('toastify:commons.toast_error_api'));
    }
  }

  const formatCSVResponse = (r) =>
    r.map((f) => ({
      ...f,
      reject_reason: f.reject_reason
        .map((r) => {
          const [value, field] = r.split(',');
          return t(`files:${value}`, { field });
        })
        .join('; '),
    }));

  async function postMassiveUser() {
    try {
      if (!file) {
        toast.error(t('toastify:user.toast_fail_file'));
        return;
      }

      if (!group) {
        toast.error(t('toastify:user.toast_fail_id_group'));
        return;
      }

      setIsImporting(true);

      const formDataUser = new FormData();

      formDataUser.append('file', file);
      formDataUser.append('id_group', group);
      formDataUser.append('send_welcome_email', checkEmail);

      const { data } = await UserData.addMassiveUser(
        formDataUser,
        myCompany.id
      );

      const createdUsers = data?.users || [];
      const invalidUsers = data?.invalidUsers || [];

      if (invalidUsers.length > 0) {
        const cols = new Set(
          invalidUsers.flatMap((item) => Object.keys(item))
        );

        const extension =
          data?.extension?.toLowerCase() === 'csv' ? 'csv' : 'excel';

        exportActionType[extension](
          [...cols].map((column) => ({
            field: column,
            title: column,
          })),
          formatCSVResponse(invalidUsers),
          t('files:Csv_fields.invalid_users_filename')
        );
      }

      if (createdUsers.length > 0 && invalidUsers.length > 0) {
        toast.warning(
          t('toastify:user.toast_send_massive_partial', {
            created: createdUsers.length,
            invalid: invalidUsers.length,
          })
        );
      } else if (createdUsers.length === 0 && invalidUsers.length > 0) {
        toast.error(
          t('toastify:user.toast_send_massive_invalid', {
            invalid: invalidUsers.length,
          })
        );
      } else {
        toast.success(t('toastify:user.toast_send_massive'));
      }

      formDataUser.delete('file');
      formDataUser.delete('id_group');
      formDataUser.delete('send_welcome_email');
    } catch (e) {
      toast.error(t('toastify:commons.toast_error_same'));
    } finally {
      setIsImporting(false);
    }
  }

  useEffect(() => {
    getPlataform();
    getGroup();
  }, []);

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item lg={9} md={10} xl={8} xs={12}>
          <Card className={classes.card}>
            <Grid
              container
              direction="column"
              spacing={3}
            >
              <Grid item xs={12}>
                <div className={classes.item}>
                  <MuiTypography
                    variant="h6"
                    className={classes.sectionTitle}
                  >
                    {t('label:User.label_download_example')}
                  </MuiTypography>
                  <Grid container spacing={2}>
                    <Grid item md={3} sm={4} xs={12}>
                      <Button
                        color="primary"
                        variant="contained"
                        className={classes.button}
                        onClick={() => customExport('excel')}
                      >
                        {t('button:User.btn_profile_example_xlsx')}
                      </Button>
                    </Grid>
                  </Grid>
                  <Alert
                    severity="info"
                    variant="outlined"
                    className={classes.infoBox}
                  >
                    <AlertTitle>
                      {t('form:User.massive_teams_title')}
                    </AlertTitle>
                    {t('form:User.massive_teams_helper')}
                  </Alert>
                </div>
              </Grid>

              <Grid item xs={12}>
                <div className={classes.item}>
                  <MuiTypography
                    variant="h6"
                    className={classes.sectionTitle}
                  >
                    {t('label:User.label_upload_archive')}
                  </MuiTypography>

                  <Grid container spacing={2} alignItems="center">
                    <Grid item md={3} sm={4} xs={12}>
                      <Button
                        color="primary"
                        variant="contained"
                        className={classes.button}
                        component="label"
                      >
                        {t('button:User.btn_profile_choose_archive')}

                        <input
                          type="file"
                          style={{ display: 'none' }}
                          onChange={(event) => {
                            setFile(event.target.files[0]);
                          }}
                          accept=".csv,.xlsx"
                        />
                      </Button>
                    </Grid>
                    <Grid item md={9} sm={8} xs={12}>
                      <MuiTypography
                        variant="body2"
                        className={classes.fileName}
                      >
                        {file?.name}
                      </MuiTypography>
                    </Grid>
                  </Grid>
                </div>
              </Grid>

              <Grid item xs={12}>
                <div className={classes.item}>
                  <MuiTypography
                    variant="h6"
                    className={classes.sectionTitle}
                  >
                    {t('label:User.label_select')}
                  </MuiTypography>

                  <Grid container spacing={2}>
                    <Grid item md={4} sm={6} xs={12}>
                      <FormControl className={classes.select}>
                        <InputLabel id="demo-simple-select-label">
                          {t('form:User.select_plataform')}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={myCompany.id ? myCompany.id : ''}
                          onChange={(e) => setMyCompany(e.target.value)}
                          disabled
                        >
                          <MenuItem key={myCompany?.id} value={myCompany?.id}>
                            {myCompany?.name}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={4} sm={6} xs={12}>
                      <FormControl className={classes.select}>
                        <InputLabel id="demo-simple-select-label">
                          {t('form:User.select_group')}
                        </InputLabel>
                        <Select
                          className={classes.select}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={group}
                          onChange={(event) => setGroup(event.target.value)}
                        >
                          {listGroup.map((group) => (
                            <MenuItem key={group.id} value={group.id}>
                              {group.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item md={4} sm={12} xs={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={checkEmail}
                            onChange={() => {
                              setCheckEmail(!checkEmail);
                            }}
                            name="checkEmail"
                          />
                        }
                        label={t('form:User.switch_email')}
                      />
                    </Grid>
                  </Grid>
                </div>
              </Grid>

              <Grid
                item
                xs={12}
                container
                spacing={2}
                justify="space-between"
                className={classes.actions}
              >
                <Grid item sm={3} xs={12}>
                  <Button
                    color="primary"
                    variant="outlined"
                    className={classes.button}
                    onClick={() => history.goBack()}
                  >
                    <ArrowBackIos style={{ marginRight: '4px' }} />
                    {t('button:commons.btn_back')}
                  </Button>
                </Grid>
                <Grid item sm={3} xs={12}>
                  <Button
                    color="primary"
                    variant="contained"
                    className={classes.button}
                    onClick={() => postMassiveUser()}
                    disabled={isImporting || !(myCompany.id && group)}
                  >
                    {t('button:commons.btn_import')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};
